import state from './moduleExternalPartnerState'
import mutations from './moduleExternalPartnerMutations'
import actions from './moduleExternalPartnerActions'
import getters from './moduleExternalPartnerGetters'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
